import { useQuery } from 'react-query';
import { fetchExaminationNotes } from '@higo/api/lib/services/examinationService';
import { useExaminationApiContext } from '@higo/common/src/features/ExaminationPage/providers';
import { ExaminationQueryKey } from '@higo/common/src/features/ExaminationPage/ExaminationQueryKey';

export const useExaminationNotesQuery = (id: number) => {
  const axios = useExaminationApiContext();

  return useQuery(
    [ExaminationQueryKey.ExaminationNotes, id],
    () => fetchExaminationNotes(axios)(id),
    {
      enabled: !isNaN(id),
      refetchOnMount: true,
    },
  );
};
